"use client";

import { create } from "zustand";

interface AccountModalState {
    open: boolean;
    /** Optional tab/section anchor — kept for parity with the legacy
     *  defaultTab prop on `<AccountModal>`. Modal currently has only one
     *  view, but plans/packs are still selected via this hint. */
    defaultTab?: string;
    /** Optional warning banner rendered at the top of the modal. Used by
     *  the «Недостаточно кредитов» path so the same modal doubles as the
     *  former PricingModal. */
    message?: string;
    openModal: (opts?: { tab?: string; message?: string }) => void;
    closeModal: () => void;
}

/** Global trigger for the «Аккаунт / Пополнить» modal. The dashboard
 *  layout mounts a single `<AccountModal>` instance that subscribes to
 *  this store, so any surface (header CTA, sidebar, mobile bottom nav,
 *  command palette, in-app pricing prompt) can open it without each one
 *  carrying its own copy of the modal. */
export const useAccountModal = create<AccountModalState>((set) => ({
    open: false,
    defaultTab: undefined,
    message: undefined,
    openModal: (opts) => set({ open: true, defaultTab: opts?.tab, message: opts?.message }),
    closeModal: () => set({ open: false, message: undefined }),
}));
